export enum JobStatus {
  PENDING = "PENDING",
  COLLECTION = "COLLECTION",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETE = "COMPLETE",
}
